import React, { useCallback, useMemo } from "react";
import * as Yup from "yup";

import { PasswordStrength, Password } from "../Forms";
import { ModalButtonGroup, ModalSaveButton } from "../../components";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import { Auth } from "../../api";
import { validatePassword } from "../../helpers/Validate";

const validationSchema = Yup.object().shape({
  current_password: Yup.string().required("Please enter the current password"),
  password: validatePassword,
  password_confirmation: Yup.string()
    .oneOf(
      [Yup.ref("password")],
      "Please enter a confirm password that matches the new password"
    )
    .required("Please enter a confirm password"),
});

function SettingsPasswordForm({ onClose }) {
  const [buttonType, setButtonType] = React.useState("");

  const location = useLocation();

  const token = useMemo(() => location?.search?.token || "", [location]);

  const onSubmit = useCallback(
    async (values, { setErrors }) => {
      try {
        setButtonType("");
        setErrors({});
        await Auth.passwordUpdate(values);
        setButtonType("success");
        setTimeout(() => onClose(), 3000);
      } catch (error) {
        setButtonType("error");
        setErrors(error?.errors || {});
      }
    },
    [onClose]
  );

  const initialValues = useMemo(
    () => ({
      current_password: "",
      password: "",
      password_confirmation: "",
      token,
    }),
    [token]
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, resetForm, isSubmitting }) => (
        <form
          id="settingsPasswordForm"
          className="form change-password__content"
          onSubmit={handleSubmit}
        >
          <div className="form__wrapper">
            <h2>Change Password</h2>
            <div className="flex-row form__row">
              <div className="form__password flex-row__stretch">
                <Password
                  label="Current Password"
                  name="current_password"
                  autoComplete="current-password"
                />
              </div>
            </div>
            <div className="flex-row form__row">
              <div className="form__password flex-row__stretch">
                <Password
                  label="New Password"
                  name="password"
                  autoComplete="new-password"
                />
              </div>
            </div>
            <div className="flex-row form__row">
              <Password
                label="Confirm Password"
                name="password_confirmation"
                autoComplete="new-password"
                className="flex-row__stretch form__confirm_password"
              />
            </div>

            <PasswordStrength />

            <div className="flex-row form__finalise-changes">
              <ModalButtonGroup>
                <button
                  className="btn_sec mr--24"
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                >
                  Cancel
                </button>
                <ModalSaveButton
                  variant={isSubmitting ? "saving" : buttonType}
                  onClick={handleSubmit}
                  onTryAgain={handleSubmit}
                >
                  Save Changes
                </ModalSaveButton>
              </ModalButtonGroup>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default SettingsPasswordForm;
